import {
	invertedThemeColors,
	invertedThemeColorsNBD,
	mainThemeColors,
	mainThemeColorsNBD,
} from '@volkswagen-onehub/tokens';

const isNewBrandDesign = (): boolean => {
	const config = JSON.parse(
		document.getElementById('spaModel')?.textContent || '{}',
	);

	return config?.spaGlobalConfig?.marketBasedFeatures?.activateNewBrandDesign;
};

export const COLOR_TOKEN = {
	main: {
		...(isNewBrandDesign() ? mainThemeColorsNBD : mainThemeColors),
	},
	inverted: {
		...(isNewBrandDesign() ? invertedThemeColorsNBD : invertedThemeColors),
	},
};
